import React from 'react'
import { Link } from 'react-router-dom'

const From = () => {
    return (
        <>
            <section id="faqs-form" className="faqs-form-main-block">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-4 col-lg-5 col-md-5">
                            <div className="faqs-form-dtls">
                                <h1 className="heading">We Can take your business</h1>
                                <p>
                                    For your car we will do everything advice, repairs and oi
                                    maintenance. We are the some preferred choice by inni many car
                                    owners because
                                </p>
                                <div className="faqs-contact-dtls">
                                    <div className="row">
                                        <div className="col-lg-2 col-3">
                                            <i className="flaticon-telephone" />
                                        </div>
                                        <div className="col-lg-10 col-9">
                                            <h4 className="help-title">Need help?</h4>
                                            <Link to="tel:(808) 555-0111" className="phone" title="">
                                                (808) 555-0111
                                            </Link>
                                            <p>444 Broklyan, New York America.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-8 col-lg-7 col-md-7">
                            <form action="">
                                <div className="row">
                                    <div className="col-lg-6 col-md-6">
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="name"
                                                placeholder="Your Name Here"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6">
                                        <div className="form-group">
                                            <input
                                                type="number"
                                                className="form-control"
                                                id="contact"
                                                placeholder="Your  Contact Here"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6">
                                        <div className="form-group">
                                            <input
                                                type="email"
                                                className="form-control"
                                                id="email"
                                                placeholder="Email Address Here"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6">
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="subject"
                                                placeholder="Subject"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <textarea
                                                className="form-control"
                                                id="message"
                                                placeholder="Your Message Here"
                                                rows={7}
                                                defaultValue={""}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <button className="btn btn-primary faqs-buttons">
                                            Discover More +
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default From
